<template>
  <vs-popup title="Safety Card 등급 기준" :active.sync="isActive" class="grade-criteria-popup">
    <div class="grade-criteria">
      <div class="ribbon-grid">
        <div v-for="grade in grades" :key="`head-${grade.name}`" class="ribbon-head">
          <div class="ribbon-bar" :style="{ background: grade.barColor }"></div>
          <div class="ribbon-circle" :style="{ background: grade.barColor }">
            <div class="ribbon-circle-inner">
              <span class="grade-name" :style="{ color: grade.color }">{{ grade.name }}</span>
              <span class="grade-point" :style="{ color: grade.color }">({{ grade.point }})</span>
            </div>
          </div>
          <div class="ribbon-arrow" :style="{ borderTopColor: grade.arrowColor }"></div>
        </div>

        <div v-for="(grade, gradeIndex) in grades" :key="`body-${grade.name}`" class="ribbon-body" :class="{ divided: gradeIndex > 0 }">
          <ul>
            <li v-for="(item, itemIndex) in grade.items" :key="`${grade.name}-${itemIndex}`">
              <span class="check" :style="{ color: grade.color }">&#10003;</span>
              <span class="item-text">{{ item }}</span>
            </li>
          </ul>
        </div>
      </div>

      <div class="notice-bar">※ 세이프티 카드의 발부권자<span class="highlight">(안전환경팀장)</span>의 판단하에 해당제도 운영 (전사 공통기준 적용)</div>
      <p class="notice-sub">※ 세이프티 카드 발급 時 대상인원 선정사유 기입 必</p>
    </div>
  </vs-popup>
</template>

<script>
export default {
  props: {
    value: Boolean,
  },
  computed: {
    isActive: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      grades: [
        {
          name: "개선",
          point: "+1점",
          color: "#3d85e0",
          barColor: "#9cc3f0",
          arrowColor: "#3d85e0",
          items: [
            "아차사고 관련 자발적 개선조치 실시",
            "사내 안전문화 확산 활동에 기여",
            "불안전한 행동·상태를 사전에 감지하여 이를 예방한 경우",
          ],
        },
        {
          name: "우수",
          point: "+2점",
          color: "#d99a2b",
          barColor: "#e7bc72",
          arrowColor: "#d99a2b",
          items: [
            "신규 중요위험 발굴 및 개선방안 수립 \n(안전개선 효과가 큰 경우)",
            "기존 중요위험 관련 신규 개선방안 수립 \n(타 공정 확대적용 가능 時)",
          ],
        },
        {
          name: "탁월",
          point: "+3점",
          color: "#e05252",
          barColor: "#ec8b8b",
          arrowColor: "#e05252",
          items: [
            "중대재해로 이어질수 있는 행동 또는 상태를 제거 또는 예방한 경우",
            "기타 안전환경팀장 판단 時, 급박한 위험을 개선 및 예방한 경우",
          ],
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.grade-criteria-popup ::v-deep .vs-popup {
  width: 1000px;
  max-width: 95vw;
}
.grade-criteria {
  padding: 8px 4px 4px;
}
.ribbon-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}
.ribbon-head {
  position: relative;
  height: 158px;
}
.ribbon-bar {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 34px;
  height: 16px;
}
.ribbon-circle {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 0;
  width: 116px;
  height: 116px;
  border-radius: 50%;
  /* 색상 링 위에 떨어지는 안쪽 그림자 (참고 디자인) */
  box-shadow: inset 0 4px 4px rgba(0, 0, 0, 0.55);
  /* 흰색 원판의 그림자가 링 밖으로 번지지 않도록 클리핑 */
  overflow: hidden;
  z-index: 1;
}
.ribbon-circle-inner {
  /* 링 두께 = 가로 바 높이(16px) */
  position: absolute;
  top: 16px;
  left: 16px;
  right: 16px;
  bottom: 16px;
  border-radius: 50%;
  background: #fff;
  /* 흰색 원판이 링 안쪽 아래로 떨어뜨리는 그림자 */
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.45);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .grade-name {
    font-size: 26px;
    font-weight: 500;
    line-height: 1.2;
  }

  .grade-point {
    font-size: 15px;
    font-weight: 700;
  }
}
.ribbon-arrow {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 6px;
  width: 0;
  height: 0;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  border-top: 13px solid;
}
.ribbon-body {
  padding: 14px 18px 18px;

  &.divided {
    border-left: 1px solid #e0e0e0;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;

    li {
      display: flex;
      gap: 8px;
      margin-bottom: 10px;
      font-size: 14px;
      line-height: 1.6;
      color: #333;
      word-break: keep-all;

      .check {
        font-weight: 700;
        flex-shrink: 0;
      }

      .item-text {
        /* 항목 문자열의 \n 을 줄바꿈으로 표시 */
        white-space: pre-line;
      }
    }
  }
}
.notice-bar {
  margin-top: 10px;
  background: #2e3f54;
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  text-align: center;
  padding: 12px 16px;
  word-break: keep-all;

  .highlight {
    color: #ffd43b;
  }
}
.notice-sub {
  margin: 12px 4px 0;
  font-size: 13px;
  font-weight: 600;
  color: #777;
  text-decoration: underline;
  word-break: keep-all;
}

@media (max-width: 768px) {
  .ribbon-grid {
    grid-template-columns: 1fr;
  }
  .ribbon-head {
    height: 140px;
  }
  .ribbon-body.divided {
    border-left: none;
    border-top: 1px solid #e0e0e0;
  }
}
</style>
